<template>
    <div>
            <div class="page select-modal">
                <div class="vertical-flow">
                    <div class="columns is-multiline">
                        <div class="column is-two-quarters">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                                tooltipLabel="msg-campo-busca-b2b-empresas"
                            />
                        </div>

                        <div class="situacao-select column is-one-quarter">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="updateSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template
                                    slot="selected-option"
                                    slot-scope="option"
                                >
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{
                                    $t("sem-resultados")
                                }}</template>
                            </v-select>
                        </div>

                        <div class="header-buttons link-company-button is-3" v-if="permissao.create">
                            <button
                                class="save-btn botao-acao"
                                type="button"
                                @click="showModalVincularTabPreco"
                            >
                                {{ $t("vincular-tabela-preco") }}
                            </button>
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            class="data-table"
                            :data="assClienteTabPreco"
                            @sort="sortTable"
                            backend-sorting
                            height="calc(100vh - 270px)"
                            sticky-header
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                class="td-center"
                                :key="i"
                                :field="f.key"
                                :label="f.key != '' ? $t(f.label) : ''"
                                :width="f.width"
                                :sortable="f.sortable"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'idcliente'">
                                    <router-link
                                        :to="{
                                            name: 'ven-cliente-edit',
                                            params: { id: props.row.idCliente },
                                        }"
                                    >
                                        <pre>{{ props.row['idCliente'] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <ButtonUpdateStatus 
                                        :service="service"
                                        :record="'associacao'"
                                        :item="props.row"
                                        :identifier="props.row.rsocial"
                                        :canDelete="permissao.delete"
                                        @loadData="carregarDados(pagination.currentPage)"
                                    />
                                </div>
                                <div v-else-if="f.key == 'idtabpreco'">
                                    {{ props.row['idTabPreco'] }}
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                    <b-modal :active.sync="showModalTabPreco" @close="fecharModal" :width="'640px'">
                        <div class="bg">
                            <ClienteTabPrecoB2BEmpresaModal 
                            @fecharModal="fecharModal"/>
                        </div>
                    </b-modal>
                </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import ButtonUpdateStatus from '@/components/shared/buttons/ButtonUpdateStatus.vue';
import ClienteTabPrecoB2BEmpresaModal from "@/components/b2b/politica-comercial/modal/ClienteTabPrecoB2BEmpresaModal"
import AssClienteTabPrecoB2BEmpresaService from "@/services/b2b/AssClienteTabPrecoB2BEmpresaService";

export default {
    components: {
        ContainerLoader,
        ButtonUpdateStatus,
        ClienteTabPrecoB2BEmpresaModal
    },
    data() {
        return {
            assClienteTabPreco: [],
            service: new AssClienteTabPrecoB2BEmpresaService(this.$http, this.$router),
            situacoes: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            situacao: { id: 2, label: "todos" },
            fields: [
                {
                    key: "idcliente",
                    label: "codigo",
                    width: '7.5%',
                    sortable: true,
                },
                {
                    key: "nome",
                    label: "nome",
                    width: '32.5%',
                    sortable: true,
                },
                {
                    key: "rsocial",
                    label: "razao-social",
                    width: '32.5%',
                    sortable: true,
                },
                {
                    key: "idtabpreco",
                    label: "codigo",
                    width: '7.5%',
                    sortable: true,
                },
                {
                    key: "descricao",
                    label: "tabela-preco",
                    width: '20%',
                    sortable: true,
                },
                { 
                    key: "situacao", 
                    width: '10%', 
                    label: "situacao"
                },
            ],
            isLoading: false,
            isEmpty: false,
            queryFilter: "",
            column: "idcliente",
            order: "asc",
            permissao: {},
            showModalTabPreco: false,

            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "b2b",
            "b2b-politica-comercial-relacao-com-cliente"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido"
            });
        }
        this.carregarDados();
    },
    methods: {
        onSearch(value) {
            this.queryFilter = this.removeToSearch(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        updateSituacao(novaSituacao) {
            if (novaSituacao) {
                this.situacao = novaSituacao;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.situacao.id,
                    this.column,
                    this.order,
                    currentPage - 1, 
                    this.pagination.perPage,
                    this.$route.params.idempresa,
                    this.queryFilter,
                )
                .then((response) => {
                    this.assClienteTabPreco = response.content;
                    this.pagination.totalRows = response.totalElements;
                    this.isEmpty = this.assClienteTabPreco.length <= 0;
                })
                .catch((error) => {
                    console.error("Erro ao carregar clientes.", error);
                    this.$root.showMessage("error", "msg-erro-dados-geral");
                    this.isEmpty = true;
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        fecharModal() {
            this.showModalTabPreco = false;
            this.carregarDados();
        },
        showModalVincularTabPreco(){
            this.showModalTabPreco = !this.showModalTabPreco;
        }
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;
}

.page {
    position: relative;
    padding-left: 0;
    .situacao-select div,
    .produtivo-select div {
        height: 40px;
    }
}

.link-company-button {
    margin-top: auto;
    padding: 12px;
}

.save-btn {
    width: 354px;
}
</style>
